import { publicRequest } from '@/core';

export default async function getGlobalPostalPlaceRequest(filter) {
	try {
		let response = await publicRequest({
			method: 'get',
			url: '/globalPostalPlace',
			params: filter
		});
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
